import styled from 'styled-components';
import {
  BACKGROUND_COLOR,
  DESKTOP_WIDTH,
  PRIMARY_COLOR,
} from '../../constants';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getIsOnDesktop } from '../../styleHelpers';

interface FooterProps {
  setShowFirstTimeModal: (show: boolean) => void;
}

const Footer = ({ setShowFirstTimeModal }: FooterProps) => {
  const baseUrl = window.location.origin;
  const navigate = useNavigate();

  const navigateToRefundPolicy = () => navigate('/refund-policy');
  const navigateToContentPolicy = () => navigate('/content-policy');
  const navigateToDisputeResolution = () => navigate('/dispute-resolution');
  const navigateTo2257Compliance = () => navigate('/2257-compliance');
  const handleContactUs = () => alert('Contact us at: hello@TheUncensored.AI');

  const [isChat, setIsChat] = useState(false);
  const [isGenerateOnDesktop, setIsGenerateOnDesktop] = useState(false);

  const currentPathName = window.location.pathname;
  useEffect(() => {
    setIsChat(currentPathName.includes('/chat'));
    
    if (getIsOnDesktop()) {
      setIsGenerateOnDesktop(currentPathName.includes('/generate'));
    }
  }, [currentPathName]);

  if (isChat) return null;

  return (
    <FooterWrapper addTopMargin={isGenerateOnDesktop}>
      <FooterContent>
        <FooterSection>
          <FooterTitle>Legal</FooterTitle>
          <FooterLink onClick={() => setShowFirstTimeModal(true)}>
            Terms of Service & Privacy Policy
          </FooterLink>
          <FooterLink onClick={navigateToContentPolicy}>
            Content Policy
          </FooterLink>
          <FooterLink onClick={navigateToDisputeResolution}>
            Dispute Resolution
          </FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Support</FooterTitle>
          <FooterLink onClick={handleContactUs}>Contact Us</FooterLink>
          <FooterLink onClick={navigateToRefundPolicy}>
            Refund Policy
          </FooterLink>
          <FooterLink onClick={navigateTo2257Compliance}>
            2257 Compliance
          </FooterLink>
        </FooterSection>

        <FooterSection>
          <FooterTitle>Company</FooterTitle>
          <FooterLink
            as="a"
            href={`${baseUrl}/features`}
            target="_blank"
            title="Browse all AI features"
          >
            Features
          </FooterLink>
          <FooterLink as="a" href={`${baseUrl}/blog`} target="_blank">
            Blog
          </FooterLink>
        </FooterSection>
      </FooterContent>

      <FooterBottom>
        <Copyright>
          © 2025 AP Software Ltd • Henry Fordin Katu 5 • All rights reserved
        </Copyright>

        <PaymentMethods>
          <PaymentLabel>Accepting:</PaymentLabel>
          <PaymentLogos>
            <PaymentLogo
              src="https://www.visa.com.sg/dam/VCOM/regional/ve/romania/blogs/hero-image/visa-logo-800x450.jpg"
              alt="visa"
            />
            <PaymentLogo
              src="https://pentagram-production.imgix.net/ee458d4d-a8e8-4177-b2a8-97df766e2e99/lh_mb_mastercard_02.jpg?rect=%2C%2C%2C&w=640&crop=1&fm=jpg&q=70&auto=format&fit=crop&h=400"
              alt="mastercard"
            />
          </PaymentLogos>
        </PaymentMethods>
      </FooterBottom>
    </FooterWrapper>
  );
};

export default Footer;

const FooterWrapper = styled.footer<{ addTopMargin: boolean }>`
  width: 80%;
  background-color: ${BACKGROUND_COLOR};
  margin-top: ${({ addTopMargin }) => (addTopMargin ? '420px' : '0')};
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  max-width: 800px;
  margin: 0 auto;
  gap: 32px;

  @media (max-width: ${DESKTOP_WIDTH}px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 24px;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 160px;
`;

const FooterTitle = styled.h3`
  color: white;
  font-size: 16px;
  margin: 0 0 16px;
  font-weight: 600;
`;

const FooterLink = styled.button`
  color: ${PRIMARY_COLOR};
  text-decoration: none;
  background: none;
  border: none;
  padding: 8px 0;
  font-size: 14px;
  text-align: left;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${DESKTOP_WIDTH}px) {
    text-align: center;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  padding-top: 24px;
  gap: 24px;
`;

const Copyright = styled.div`
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  text-align: center;
`;

const PaymentMethods = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const PaymentLabel = styled.span`
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
`;

const PaymentLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const PaymentLogo = styled.img`
  width: 64px;
  height: 40px;
  object-fit: contain;
  border-radius: 4px;
`;
